// store/index.js
import { createStore } from 'vuex';
import axios from 'axios';

export default createStore({
  state: {
    isLoggedIn: localStorage.getItem('isLoggedIn') === 'true',
    token: localStorage.getItem('access_token') || null

  },
  mutations: {
    setLoggedIn(state, status) {
      state.isLoggedIn = status;
      localStorage.setItem('isLoggedIn', status);
    },
    setToken(state, token) {
      state.token = token;
      localStorage.setItem('access_token', token);
    },
    clearToken(state) {
      state.token = null;
      localStorage.removeItem('access_token');
      localStorage.removeItem('isLoggedIn');
    }
  },
  actions: {
    async login({ commit }, credentials) {
      try {
        const response = await axios.post('/api/login', credentials);
        const token = response.data.access_token; // 确保这里使用 access_token
        commit('setToken', token);
        commit('setLoggedIn', true);
      } catch (error) {
        console.error('登录失败:', error);
        commit('setLoggedIn', false);
        commit('clearToken');
        throw error; // 抛出错误以便在组件中处理
      }
    },
    logout({ commit }) {
      commit('setLoggedIn', false);
      commit('clearToken');
    },
    async checkToken({ commit, state }) {

      if (state.token) {
        try {
          const response = await axios.get('/api/validate-token', {
            headers: {
              'Authorization': `Bearer ${state.token}`
            }
          });
          if (response.data.isValid) {
            commit('setLoggedIn', true);
          } else {
            commit('setLoggedIn', false);
            commit('clearToken');
          }
        } catch (error) {
          console.error('验证 token 失败:', error);
          commit('setLoggedIn', false);
          commit('clearToken');
        }
      } else {
        commit('setLoggedIn', false);
      }
    }
  },
  getters: {
    isLoggedIn: state => state.isLoggedIn,
    token: state => state.token

  }
});
